"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.complete.hero.title': 'Welcome to IntHub!',
    'register.complete.hero.description': 'Your account has been created successfully. Please check your email to activate your account.',
    'register.complete.title': 'Registration Successful!',
    'register.complete.description': 'Thank you for joining IntHub. We\'ve sent an activation email to your address.',
    'register.complete.email.check': 'Please check your email inbox and click the activation link to complete your registration.',
    'register.complete.login.button': 'Go to Login',
    'register.complete.home.button': 'Back to Home',
    'register.complete.help.text': 'Need help?',
    'register.complete.help.link': 'Contact Support',
};
